import {
  Toast,
  ToastClose,
  ToastProvider,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/hooks/useToast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="relative flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
              {title && (
                <span className="font-semibold text-sm whitespace-nowrap">
                  {title}
                </span>
              )}
              {description && (
                <span className="text-xs text-zinc-600 dark:text-zinc-400">
                  {description}
                </span>
              )}
              {action && <span className="ml-2">{action}</span>}
            </div>
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
